import { getUlxVisitorId } from './CookieUtil';

const logPath = '/list/log';

export default function log(tags, event, data) {
    try {
        if (typeof window === 'object') {
            const fixedData = {
                visitorId: getUlxVisitorId()
            };
            const xhr = new XMLHttpRequest();
            const payload = {
                tags,
                event,
                data: { ...fixedData, ...data }
            };
            xhr.open('POST', logPath);
            xhr.send(JSON.stringify(payload));
        }
    } finally {
        // This is a fire and forget method, so just silently fail.
    }
}
